<div class="container simulator-widget" [ngStyle]="{'font-size':fontSize}" (window:resize)="onResize($event)">
	<div class="row">
		<div class="col-lg-9 col-xs-12 p-0" id="simulator">
			<div class="simulator-wrap" #simulatorWrap>
				<!--<div class="imageSeal"></div>-->
				<img class=" background-image" [ngClass]="{'debug':_debug}" src="assets/img/ai_bg.png" />
				<!--<div *ngIf="!debug" class="imageSeal" [ngClass]="{'debug':debug}"></div>-->
				<!--<img src="/assets/img/sensoCOMFORT_Clean.png"/>-->
				<button *ngIf="hasButton('question')" (click)="questionClicked()"
					class="simulator-control-button question-button"
					[ngClass]="{'debug':_debug,'off':hasNotButton('question'),'white':whiteQuestionMark(),'blinking':buttonBlinking('question')}"></button>
				<button *ngIf="hasButton('back')" (click)="backClicked()" class="simulator-control-button back-button"
					[ngClass]="{'debug':_debug,'off':hasNotButton('back'),'blinking':buttonBlinking('back')}"></button>
				<button *ngIf="hasButton('menu')" (mousedown)="buttonDown('menu')" (mouseup)="buttonUp('menu')"
					(click)="menuClicked()" class="simulator-control-button menu-button"
					[ngClass]="{'debug':_debug,'off':hasNotButton('menu'),'white':whiteMenuButton() && hasButton('menu'),'blinking':buttonBlinking('menu')}"></button>
				<button *ngIf="hasButton('confirm')" (click)="confirmClicked()"
					class="simulator-control-button confirm-button"
					[ngClass]="{'debug':_debug,'off':hasNotButton('confirm'),'blinking':buttonBlinking('confirm')}"></button>
				<button *ngIf="hasButton('up')||hasButton('slider')" (panStart)="onPanStart($event)"
					(mousedown)="upPressed($event)" (mouseleave)="upReleased($event)" (mouseup)="upReleased($event)"
					(panEnd)="onPanEnd($event)" (panUp)="onPanUp($event)" (panDown)="onPanDown($event)"
					(click)="menuUpClicked()" class="simulator-control-button menu-up-button"
					[ngClass]="{'debug':_debug,'off':(hasNotButton('up')||hasNotButton('slider')), 'blinking':buttonBlinking('up')}"></button>
				<button *ngIf="hasButton('down')||hasButton('slider')" (mousedown)="downPressed($event)"
					(mouseup)="downReleased($event)" (mouseleave)="downReleased($event)" (panStart)="onPanStart($event)"
					(panEnd)="onPanEnd($event)" (panUp)="onPanUp($event)" (panDown)="onPanDown($event)"
					(click)="menuDownClicked()" class="simulator-control-button menu-down-button"
					[ngClass]="{'debug':_debug,'off':(hasNotButton('down')||hasNotButton('slider')), 'blinking':buttonBlinking('down')}"></button>
				<button *ngIf="hasButton('power')" (mousedown)="buttonDown('power')" (mouseup)="buttonUp('power')"
					(click)="powerClicked()" class="simulator-control-button power-button"
					[ngClass]="{'debug':_debug,'off':hasNotButton('power'),'blinking':buttonBlinking('power')}"></button>
				<button *ngIf="hasButton('dhw')" (mousedown)="buttonDown('dhw')" (mouseup)="buttonUp('dhw')"
					(click)="dhwClicked()" class="simulator-control-button dhw-button"
					[ngClass]="{'debug':_debug,'off':hasNotButton('dhw'),'blinking':buttonBlinking('dhw'),'white':whiteDHWButton()}"></button>
				<button *ngIf="hasButton('heating')" (mousedown)="buttonDown('heating')" (mouseup)="buttonUp('heating')"
					(click)="heatingClicked()" class="simulator-control-button heating-button"
					[ngClass]="{'debug':_debug,'off':hasNotButton('heating'),'blinking':buttonBlinking('heating'), 'white':whiteHeatingButton()}"></button>
				<button *ngIf="hasButton('chimney')" (click)="chimneyClicked()"
					class="simulator-control-button chimney-button"
					[ngClass]="{'debug':_debug,'off':hasNotButton('chimney'),'blinking':buttonBlinking('chimney')}"></button>
				<app-click-indicator [ngClass]="command().highlightedButton()"
					class="click-animation"></app-click-indicator>
				<app-screen [ngClass]="{'debug':_debug}"></app-screen>

			</div>
		</div>
		<div class="hidden-lg col-xs-12"></div>
		<div class="col-lg-3 col-xs-12 simulator-info">
			<div class="col-lg-1 hidden-xs"></div>
			<input type="file" (change)="loadScript($event)" [hidden]="true" #scriptFile accept=".simscript">



			<div *ngIf="true" class="col-lg-11 simulator-info-widget" [ngClass]="{'debug':_debug}">
				<div class="caption">
					<!--<button type="button" (click)="goToSetup()" class="close float-right" aria-label="Close"> <span aria-hidden="true">&times;</span></button>-->
					<h4>{{caption}}</h4>
					<!--<hr/>-->
				</div>
				<div class="info-text-container p-2 col-12">
					<!--<pre *ngIf="!infoText">{{menuService.getCurrentNode().toDebugMap() |json}}</pre>-->
					{{infoText}}
				</div>

				<button type="button" id="endSimulationButton" (click)="goToSetup($event)"
					class="p-2 float-right btn btn-small btn-info bg-vaillant-green"
					aria-label="Close">{{getTranslator().tr('BUTTON_END_SIMULATION_CAPTION')}}
					<!--&nbsp;<span aria-hidden="true">&times;</span>--></button>
			</div>

		</div>
	</div>
</div>